import { MeetingParams } from '../pages/meeting-view/types/types'
import { getSessionParameters } from '../helpers/urls'
import jwtDecode from 'jwt-decode'

export const useSessionParams = () => {
    const { widgetToken: token, ...params } = getSessionParameters()

    let payload: Partial<MeetingParams> = {}

    try {
        if (token) payload = jwtDecode<MeetingParams>(token)
    } catch (error) {}

    return {
        token,
        ...payload,
        ...params,
    }
}
